import Reveal from './Reveal';
import { quickProfile } from '@/mocks/home';

export default function QuickProfile() {
  return (
    <section id="profile" className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.3em] text-secondary-700 uppercase">Profile / 人物档案</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">四个关键词，先认识她</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              「玩偶姐姐」并不是她的真名，而是一个被沿用了数年的网络昵称。理解这个名字，通常可以从下面四个角度入手。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {quickProfile.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 70}>
              <div className="h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-5">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}